import { Link } from "react-router-dom";
import { FC, useContext } from "react";
import { Store } from "../../../context/store";
export const MainNavigation = () => {
  const store = useContext(Store);
  return (
    <nav className="sticky inset-x-0 top-0 z-50 shadow-md bg-gray-25">
      <div className="flex items-center justify-between px-4 py-3 mx-auto sm:px-6 lg:px-8 ">
        <Link to={store.company?.website ?? ""}>
          <img
            className="object-contain h-8"
            src={store.company?.logoUrl}
            alt="Go Home"
          />
        </Link>
      </div>
    </nav>
  );
};
